import React from 'react'
import { Alert, Button, Container, Heading, Paragraph } from '@health-zelas/delta'

import { Dialog } from '@packages/components'
import { ShareResult } from './components/ShareResult'
import Step from '../../components/Step'
import ProgressBar from '../../components/ProgressBar'

import { formatPrice } from '../../utils/formatPrice'
import { useResultController } from './useResultController'

import * as S from './Result.styles'

export function Result(){
  const {
    products,
    handleOpenShareResultModal,
    handleCloseShareResultModal,
    shareResultModalIsVisible,
    isLoading,
    shareableLink,
    alternativeProducts
  } = useResultController()

  return (
    <Step isLastStep hasProducts={!!products?.length}>
      <Container>
        <S.Wrapper>
          <ProgressBar title="Resultado" fill={4} lastStep="Concluído" />

          <Heading
            size="lg"
            weight="bold"
            css={{
              marginBottom: '$xxs',

              '@md': {
                marginBottom: '$xs'
              }
            }}
          >
            {isLoading ? 'Carregando...' : !!products?.length ? (
              <>
                Sua simulação está pronta! <span role="img" aria-label="rosto sorrindo">😁</span>
              </>
            ) : (
              <>
                Não encontramos opções de planos dentro do valor desejado <span role="img" aria-label="rosto sorrindo">😕</span>
              </>
            )}
          </Heading>

          {!isLoading && (
            <>
              <Paragraph
                css={{
                  marginBottom: '$md',
                  color: '$neutralDark',
                  fontSize: '20px',

                  '@md': {
                    marginBottom: '$xs'
                  }
                }}
              >
                {!!products?.length
                  ? 'Aguarde que, em até um dia útil, especialistas entrarão em contato via WhatsApp ou telefone.'
                  : 'Experimente ajustar os valores e opções, ou aguarde o contato de uma pessoa especialista da Zelas Saúde pra te ajudar!'
                }
              </Paragraph>

              <S.ButtonGroup>
                <Button
                  as="a"
                  href="/simulador"
                  id="button-new-simulation"
                >
                  Nova simulação
                </Button>

                <Button
                  type="button"
                  outlined
                  onClick={handleOpenShareResultModal}
                  id="button-open-share-modal"
                >
                  Compartilhar
                </Button>
              </S.ButtonGroup>

              <Alert title="Dica da Zelas Saúde:">
                Essa é uma simulação. As condições apresentadas baseiam-se no Estado de São Paulo, e estão sujeitas a alterações por parte das operadoras.
              </Alert>

              <Paragraph
                size="lg"
                css={{
                  marginBlock: '$xxs',
                  fontSize: '24px',
                  color: '$neutralDark',
                  fontWeight: 'bold',

                  '@md': {
                    marginBlock: '$xs'
                  }
                }}
              >
                {products?.length ? 'Confira os planos que encontramos pra você:' : 'Confira outros planos que encontramos pra você:'}
              </Paragraph>

              {!!products && products.length > 0 && (
                <S.ProductList>
                  {products.map((product) => (
                    <S.ProductCard key={product.id}>
                      <S.ProductCardLogo
                        src={product?.brand?.logo || ''}
                        alt={product?.brand?.name || ''}
                      />
                      <Heading weight="bold">{product.name}</Heading>
                      <div>
                        <Paragraph>A partir de</Paragraph>
                        <S.ProductCardPrice>
                          {formatPrice(product?.price || 0)}
                          <span>/mês</span>
                        </S.ProductCardPrice>
                      </div>
                      <Paragraph size="sm" css={{ color: '$neutralDark' }}>
                        Valor total estimado. Para mais detalhes, aguarde o contato de um especialista.
                      </Paragraph>
                    </S.ProductCard>
                  ))}
                </S.ProductList>
              )}

              {!!alternativeProducts && alternativeProducts.length > 0 && (
                <S.ProductList>
                  {alternativeProducts.map((product) => (
                    <S.ProductCard key={product.id}>
                      <S.ProductCardLogo
                        src={product?.brand?.logo || ''}
                        alt={product?.brand?.name || ''}
                      />
                      <Heading weight="bold">{product.name}</Heading>
                      <div>
                        <Paragraph>A partir de</Paragraph>
                        <S.ProductCardPrice>
                          {formatPrice(product?.price || 0)}
                          <span>/mês</span>
                        </S.ProductCardPrice>
                      </div>
                      <Paragraph size="sm" css={{ color: '$neutralDark' }}>
                        Valor total estimado. Para mais detalhes, aguarde o contato de um especialista.
                      </Paragraph>
                    </S.ProductCard>
                  ))}
                </S.ProductList>
              )}

              <Dialog
                closeId="close-share-modal"
                isVisible={shareResultModalIsVisible}
                onClose={handleCloseShareResultModal}
              >
                <ShareResult hash={shareableLink} />
              </Dialog>
            </>
          )}
        </S.Wrapper>
      </Container>
    </Step>
  )
}
